/* Tarteaucitron init — France Éternelle CMP */
(function() {
  if (typeof tarteaucitron === 'undefined') {
    console.warn('[FE] Tarteaucitron not loaded');
    return;
  }
  var _feInitTac = function() {
  tarteaucitron.init({
    "privacyUrl": "/pages/cookies",
    "bodyPosition": "bottom",
    "hashtag": "#tarteaucitron",
    "cookieName": "tarteaucitron",
    "orientation": "bottom",
    "groupServices": false,
    "showDetailsOnClick": true,
    "serviceDefaultState": "wait",
    "showAlertSmall": true,
    "cookieslist": true,
    "closePopup": false,
    "showIcon": true,
    "iconPosition": "BottomRight",
    "adblocker": false,
    "DenyAllCta": true,
    "AcceptAllCta": true,
    "highPrivacy": true,
    "handleBrowserDNTRequest": false,
    "removeCredit": false,
    "moreInfoLink": true,
    "useExternalCss": false,
    "useExternalJs": false,
    "readmoreLink": "/pages/politique-confidentialite",
    "mandatory": true,
    "mandatoryCta": true,
    "googleConsentMode": true,
    "partnersList": false
  });
  if (typeof tarteaucitronForceLanguage !== 'undefined') { tarteaucitronForceLanguage = "fr"; }
  };
  if ('requestIdleCallback' in window) { requestIdleCallback(_feInitTac, { timeout: 2500 }); }
  else { setTimeout(_feInitTac, 1200); }
})();

/* When user accepts GA4, fire our gated GA4 loader + flag for our custom events */
document.addEventListener('tac.gtag_loaded', function() {
  try { localStorage.setItem('fe_consent_analytics', 'true'); } catch(e) {}
});

/* When user denies / removes consent, clear flag */
document.addEventListener('tac.gtag_removed', function() {
  try { localStorage.setItem('fe_consent_analytics', 'false'); } catch(e) {}
});
